import React from 'react';

/**
 * VocabCollectionSelector — shown on all generation surfaces when >1 collection exists.
 * activeCollections: string[] — currently selected collections (null = all)
 * onChange: (string[] | null) => void
 */
export function VocabCollectionSelector({ vocabCollections, activeCollections, onChange }) {
  if (!vocabCollections || vocabCollections.length <= 1) return null;

  const effective = activeCollections || vocabCollections;

  const toggle = (col) => {
    const base = activeCollections || vocabCollections;
    const next = base.includes(col)
      ? base.filter(c => c !== col)
      : [...base, col];
    if (next.length === 0) return; // prevent deselecting all
    // If all selected, pass null to mean "all"
    onChange(next.length === vocabCollections.length ? null : next);
  };

  return (
    <div className="vcol-selector" data-testid="vocab-collection-selector">
      <span className="vcol-selector-label">Vokabulärsamlingar:</span>
      <div className="vcol-chips">
        {vocabCollections.map(col => (
          <button
            key={col}
            type="button"
            className={`vcol-chip${effective.includes(col) ? ' vcol-chip--on' : ''}`}
            onClick={() => toggle(col)}
            data-testid={`vcol-chip-${col}`}
          >
            {col}
          </button>
        ))}
      </div>
    </div>
  );
}
